export default "__VITE_ASSET__DuliZZfd__"